import { ITeamLastNextMatch, TeamLastNextMatch } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LastAndNextMatchQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LastAndNextMatchQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<LastAndNextMatchQuery>): ITeamLastNextMatch => {
  return transformer(props);
}

const TeamLastNextMatchWidget = ({
  props,
  ...rest
}: WidgetContext<ITeamLastNextMatch>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <TeamLastNextMatch {...props} />
    </div>
  );
}

export default TeamLastNextMatchWidget;